import { Flex, Grid, Status, Text } from '@pega/cosmos-react-core';
import React from 'react';
import styled, { css } from 'styled-components';
import { CustomerStatus } from '../../../../constants/common';

export interface CustomerListProps {
  customerData: any;
  onCustomerClick: any;
  selectedCustomer: any;
}

const gridStyle = {
  padding: '0.7rem 0.4rem',
  borderBottom: '0.06rem solid #D8D8D8',
  width: '100%',
  cursor: 'pointer',
};

const gridStyleSelected = {
  ...gridStyle,
  borderRight: '6px solid #076bc9',
};

const StyledLinkHover = styled.div(
  () =>
    css`
      :hover {
        background-color: #e9eef3;
      }
    `,
);

const CustomerList: React.FC<CustomerListProps> = ({ customerData, onCustomerClick, selectedCustomer }) => {
  const getStatus = (status: string) => {
    switch (status as CustomerStatus) {
      case CustomerStatus.Resolved:
        return 'success';
      case CustomerStatus.Initializing:
        return 'pending';
      default:
        return 'info';
    }
  };

  return (
    <>
      {Object.keys(customerData).length > 0 && (
        <Flex container={{ direction: 'column', alignItems: 'start' }}>
          {customerData.map((item: any, index: any) => {
            return (
              <Grid
                style={item.customerId === selectedCustomer?.customerId ? gridStyleSelected : gridStyle}
                key={index}
                onClick={() => {
                  onCustomerClick(item?.customerId);
                }}
                as={StyledLinkHover}
              >
                <Text
                  variant="secondary"
                  style={{ fontWeight: item.customerId === selectedCustomer?.customerId ? 'bold' : 'normal' }}
                >
                  {item.bio?.full_name}
                  {item?.status && (
                    <Status variant={getStatus(item?.status)} style={{ float: 'right' }}>
                      {item?.status}
                    </Status>
                  )}
                </Text>
              </Grid>
            );
          })}
        </Flex>
      )}
    </>
  );
};

export default CustomerList;
